/* Remove the decorative northeast character, including emoji variation selectors. */
(() => {
  function clean(root) {
    root.querySelectorAll('a,button').forEach(control => {
      if (control.closest('[contenteditable="true"]')) return;
      const walker=document.createTreeWalker(control,NodeFilter.SHOW_TEXT), nodes=[];
      while(walker.nextNode())nodes.push(walker.currentNode);
      nodes.forEach(node=>{
        if(node.parentElement?.closest('svg'))return;
        const text=node.textContent.replace(/↗[\uFE0E\uFE0F]?\s*$/u,'');
        if(text===node.textContent)return;
        node.textContent=text;
        const holder=node.parentElement;
        if(holder!==control&&holder.matches('span[aria-hidden="true"],i[aria-hidden="true"]')&&!holder.textContent.trim()&&!holder.children.length)holder.remove();
      });
    });
  }
  function start(){
    clean(document);
    document.addEventListener('shopify:section:load',event=>clean(event.target));
    new MutationObserver(records=>{for(const record of records)for(const node of record.addedNodes)if(node.nodeType===1)clean(node.parentElement||node);}).observe(document.body,{childList:true,subtree:true});
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
})();
